import React from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import CustomLoader from "../CustomLoader";
import { useTranslation } from "react-i18next";

const ConfirmationDialog = ({
  isOpen,
  reset,
  title,
  content = "",
  handleCancel = reset,
  handleContinue = reset,
  isLoadingDailog = true,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <Dialog
      open={isOpen}
      onClose={reset}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          style={{
            //styleName: Semibold/20—Pane header;
            fontFamily: "Segoe UI",
            fontSize: 20,
            fontWeight: 600,
            textAlign: "left",
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontFamily: "Segoe UI",
            fontSize: 18,
            fontWeight: 400,
            textAlign: "left",
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          style={{
            alignSelf: "center",
            width: 86,
            height: 32,
            marginLeft: 21,
            marginBottom: 3,
            display: "flex",
            backgroundColor: "#fff",
            borderColor: "#8A8886",
            color: "#605E5C",
            borderRadius: 4,
          }}
          onClick={() => {
            handleCancel && handleCancel();
            reset();
          }}
        >
          <Typography
            variant="buttonText"
            color="common.buttonText"
            style={{ color: "#000" }}
          >
            {t("commonLabels.text02")}
          </Typography>
        </Button>
        <Button
          onClick={() => {
            setIsLoading(true);
            handleContinue && handleContinue();
          }}
          disabled={isLoading}
          variant="contained"
          style={{
            alignSelf: "center",
            width: 106,
            height: 32,
            right: 10,
            marginLeft: 40,
            marginBottom: 3,
            display: "flex",
            borderRadius: 4,
            border: 1,
          }}
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("commonLabels.text17")}
          </Typography>
        </Button>
      </DialogActions>
      {isLoading && isLoadingDailog && <CustomLoader />}
    </Dialog>
  );
};

export default ConfirmationDialog;
